import _typeof from '@babel/runtime/helpers/typeof';
import '@babel/runtime/helpers/slicedToArray';
import { map } from 'rxjs/operators';

var months = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'];
var monthsShort = ['янв', 'фев', 'мар', 'апр', 'май', 'июнь', 'июль', 'авг', 'сент', 'окт', 'нояб', 'дек'];
var week = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
/**
 * Функция для добавления окончаний к месяцам
 * @param value - имя месяца
 *
 */

var getMonthName = function getMonthName(value) {
  if (value) {
    var arr = value.split('');
    var result;

    if (months.indexOf(value) !== -1) {
      arr.splice(arr.length - 1, 1, 'я');
      result = arr.join('');
      return result;
    }

    arr.push('а');
    result = arr.join('');
    return result;
  }

  return '';
};
/** Добавить нули */

var addLeadingZeros = function addLeadingZeros(number) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return ('0'.repeat(length) + number).slice(-length);
};
/**
 * Функция для форматирования даты
 *  @param date - дата, которую нужно преобразовать
 *
 */

var formatDate = function formatDate(date) {
  if (!date) {
    date = Date.now();
  }

  var tempDate = new Date(date);
  var month = addLeadingZeros(tempDate.getMonth() + 1);
  var monthLong = getMonthName(months[tempDate.getMonth()]);
  var monthName = months[tempDate.getMonth()];
  var monthShort = monthsShort[tempDate.getMonth()];
  var dayOfMonth = addLeadingZeros(tempDate.getDate());
  var dayOfWeek = week[tempDate.getDay()];
  var tempHour = tempDate.getHours();
  var hour = addLeadingZeros(tempHour);
  var tempMinutes = tempDate.getMinutes();
  var minutes = addLeadingZeros(tempMinutes);
  var year = tempDate.getFullYear();
  return {
    month: month,
    monthLong: monthLong,
    monthShort: monthShort,
    monthName: monthName,
    dayOfMonth: dayOfMonth,
    dayOfWeek: dayOfWeek,
    hour: hour,
    minutes: minutes,
    year: year,
    date: "".concat(dayOfMonth, ".").concat(month, ".").concat(year),
    time: "".concat(hour, ":").concat(minutes)
  };
};
var sizeClass = {
  'xxxs': 'rf--xxxs',
  'xxs': 'rf--xxs',
  'xs': 'rf--xs',
  's': 'rf--s',
  'm': 'rf--m',
  'l': 'rf--l',
  'xl': 'rf--xl',
  'xxl': 'rf--xxl',
  'xxxl': 'rf--xxxl',
  'xxxxl': 'rf--xxxxl'
};
var iconSize = {
  'xxxs': '16',
  'xxs': '20',
  'xs': '24',
  's': '32',
  'm': '40',
  'l': '48',
  'xl': '56',
  'xxl': '64',
  'xxxl': '72',
  'xxxxl': '80'
};

function oDataServ(data) {
  data.results && (data = data.results);

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      key === '__metadata' && delete data[key];

      if (Array.isArray(data[key])) {
        data[key].forEach(function (item) {
          oDataServ(item);
        });
      } else if (_typeof(data[key]) === 'object') {
        data[key] = oDataServ(data[key]);
      }
    }
  }

  return data;
}

var oDataTransform = function oDataTransform() {
  return map(function (data) {
    delete data['@odata.context'];
    delete data['@odata.metadataEtag'];
    return data.d ? oDataServ(data.d) : data;
  });
};
/** Функция для добавления пробелов в число */

var numberWithSpaces = function numberWithSpaces(x) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';
  var parts = x.toString().split('.');
  var regex = new RegExp("\\B(?=(\\d{".concat(n, "})+(?!\\d))"), 'g');
  parts[0] = parts[0].replace(regex, s);
  return parts.join('.');
};
var UTCToLocal = function UTCToLocal(date) {
  var offset = -new Date().getTimezoneOffset();
  var withOffset = new Date(date).getTime() + offset * 60000;
  return new Date(withOffset);
};
var LocalToUTC = function LocalToUTC(date) {
  var offset = -new Date().getTimezoneOffset();
  var withOffset = new Date(date).getTime() - offset * 60000;
  return new Date(withOffset);
};
/** Выделить текст из HTML */

var extractTextFromHTML = function extractTextFromHTML(element) {
  var result = '';
  var skip = false;

  for (var i = 0; i < element.length; i++) {
    if (element[i] === '<') {
      skip = true;
    }

    if (element[i] === '>') {
      skip = false;
      continue;
    }

    if (skip) {
      continue;
    }

    result += element[i];
  }

  return result;
};
/** Debounce */

function debounce(fn, ms) {
  var timeout;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // @ts-ignore
    var fnCall = function fnCall() {
      return fn.apply(_this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(fnCall, ms);
  };
}
/** Сегодня приведенное к 00:00:00 */

var today = function today() {
  var utc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return utc ? UTCToLocal(date).getTime() : date.getTime();
};

export { LocalToUTC, UTCToLocal, addLeadingZeros, debounce, extractTextFromHTML, formatDate, getMonthName, iconSize, numberWithSpaces, oDataTransform, sizeClass, today };
